import axios from 'axios';
import {BaseResponse} from "../../BaseResponse";

export async function deleteGasProduct(uid : string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/basic/gas_product/${uid}`)

    return response.data
}

